import { RenderBenefitProps } from "./render-benefit-types";
import TypeBenefit from "./components/type-benefit/type-benefit";
import useFetch from "@/hook/useFetch/useFetch";
import { validateIfUserClaimedBenefit } from "@/services/benefits/benefit";
import { useEffect } from "react";

const RenderBenefit: React.FC<RenderBenefitProps> = ({ benefits, participant, isCompleted, mission, typeObjective, setIsClaimed, setIsValidateClaim }) => {
  const participantID = Array.isArray(participant) && participant.length > 0 ? participant[0].id : null;
  const userMainKey = Array.isArray(participant) && participant.length > 0 ? participant[0].user_main_key : null;
  const params ={
    participant_id: participantID,
    benefit_of_mission_mission_id: mission?.id
  }

  const { data, loading } = useFetch(validateIfUserClaimedBenefit, params, { autoFetch: Boolean(participantID) });
  const isClaimed = Boolean(data?.length > 0);

  useEffect(()=>{
    setIsClaimed(isClaimed);
  },[isClaimed, setIsClaimed])

  useEffect(()=>{
    setIsValidateClaim(loading);
  },[loading, setIsValidateClaim])

  return (
    <div style={{ margin: '0 auto', width: '100%' }}>
    <div style={{ 
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '16px',
      padding: '32px 0'
    }}>
      {benefits?.map((benefit, index) => {
        const id = index;
        return (
          <TypeBenefit 
            key={id} 
            benefit={benefit} 
            isCompleted={isCompleted} 
            isClaimed={isClaimed} 
            idMission={mission?.id} 
            isLoad={loading} 
            userMainKey={userMainKey}
            typeObjective={typeObjective}
            setIsClaimed={setIsClaimed}
          />
        )
      })}
    </div>
    </div>
  )
}

export default RenderBenefit;
